import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {
	fetchAllLevelsProperties,
	fetchAllUserLevels,
	setCurrentExtraLevel,
	setCurrentGameType
} from "../../ducks/duck-game";
import {updateScrollPosition} from "../../ducks/duck-screen";

import ExtraLevelsScreen from "./extra-levels-screen";

function compare(a,b) {
	if (a.lp < b.lp)
		return -1;
	if (a.lp > b.lp)
		return 1;
	return 0;
}

function ExtraLevelsScreenContainer(props) {
	const extraLevels = [];

	for (let level in props.gameTypesProperties){
		if(props.gameTypesProperties.hasOwnProperty(level)){
			if (level !== 'classic'){
				extraLevels.push(props.gameTypesProperties[level])
			}
		}
	}
	// console.log(extraLevels);
	extraLevels.sort(compare);
	return (
		<ExtraLevelsScreen extraLevels={extraLevels} {...props}/>
	);
}

ExtraLevelsScreenContainer.propTypes = {
	allUserLevelsDownloaded: PropTypes.bool.isRequired,
	allLevelPropertiesDownloaded: PropTypes.bool.isRequired,
	isSound: PropTypes.bool.isRequired,
	isVibrate: PropTypes.bool.isRequired,
	collectedRiddlesForAllLevels: PropTypes.number.isRequired,
	uid: PropTypes.string.isRequired,

	gameTypesProperties: PropTypes.object.isRequired,
	scrollPositions: PropTypes.object.isRequired,
	collectedRiddlesForGameType: PropTypes.object.isRequired,
	riddleCountForGameType: PropTypes.object.isRequired,

	push: PropTypes.func.isRequired,
	setCurrentGameType: PropTypes.func.isRequired,
	fetchAllUserLevels: PropTypes.func.isRequired,
	updateScrollPosition: PropTypes.func.isRequired,
	setCurrentExtraLevel: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
	const settings = state.userReducer.settings;

	let isSound = false;
	if(settings && settings.isSound){
		isSound = true;
	}

	let isVibrate = false;
	if(settings && settings.isVibrate){
		isVibrate = true;
	}

	return {
		gameTypesProperties: state.configReducer.appConfig.gameTypesProperties,
		allLevelPropertiesDownloaded: state.gameReducer.allLevelPropertiesDownloaded,
		allUserLevelsDownloaded: state.gameReducer.allUserLevelsDownloaded,
		collectedRiddlesForGameType: state.gameReducer.collectedRiddlesForGameType || {},
		collectedRiddlesForAllLevels: state.gameReducer.collectedRiddlesForAllLevels,
		scrollPositions: state.screenReducer.scrollPositions,
		riddleCountForGameType: state.gameReducer.riddleCountForGameType,
		uid: state.userReducer.uid,
		isSound,
		isVibrate
	};
}

export default connect(mapStateToProps,
	{ setCurrentGameType,
		fetchAllUserLevels,
		fetchAllLevelsProperties,
		updateScrollPosition,
		setCurrentExtraLevel })(ExtraLevelsScreenContainer);